<template>
  <section class="merge-area">
    <!--FIXME если слияние залочено ролью, то кнопка просто в блок уходит,
     то же происходит с дропом на смену статуса, не оч это очевидно с точки зрения UI/UX, может логичнее сносить элементы -->
    <label
      class="font-weight-bolder text-secondary"
      v-if="mergeRequest?.autoMergeEnabled"
    >
      {{ $t('manual_merge_disabled') }}
    </label>
    <div class="d-flex">
      <div
        :class="mergeRequest.canMerge ? 'border-success' : 'border-warning'"
        class="w-100 rounded border bg-light mb-3"
      >
        <div class="d-flex bg-light rounded-top px-3 pt-3 align-items-center">
          <div class="d-flex align-items-center flex-column">
            <i
              :class="mergeRequest.canMerge ? 'text-success' : 'text-warning'"
              class="gf-icon gf-icon-clipboard-check gf-fs-6"
            />
          </div>
          <div class="d-flex flex-column ml-3 font-weight-bold">
            {{ mergeRequest.mergeStatus.title }}
          </div>
          <div class="merge-area__open-requirements">
            <router-link
              v-if="mergeRequest.canConflictsBeResolvedInUI"
              tag="a"
              :to="{ name: 'merge-request-conflicts' }"
              class="btn btn-sm btn-success"
            >
              {{ $t('resolveConflicts') }}
            </router-link>
            <button
              class="btn btn-sm border"
              @click="isOpenMergeRequirements = !isOpenMergeRequirements"
            >
              <i
                class="gf-icon"
                :class="isOpenedMergeRequirementsIcon"
              ></i>
            </button>
          </div>
        </div>
        <div
          v-show="isOpenMergeRequirements"
          class="merge-area__requirement-status mx-5"
        >
          <div
            v-for="(requirementStatus, index) in mergeRequest.mergeRequestRequirementsStatuses"
            :key="index"
            class="d-flex px-3 py-1 gap-2"
          >
            <div class="w-100">
              <div class="d-flex align-items-center">
                <i
                  v-if="requirementStatus.accepted"
                  class="text-success gf-icon gf-icon-check-circle mr-1"
                ></i>
                <i
                  v-else
                  class="text-danger gf-icon gf-icon-x-circle mr-1"
                ></i>
                {{ requirementStatus.message }}
                <button
                  v-if="
                    requirementStatus.mergeRequestRequirement === 'NO_CONFLICTS' &&
                    !requirementStatus.accepted
                  "
                  class="btn btn-sm merge-area__open-conflicts ml-2"
                  @click="isOpenConflicts = !isOpenConflicts"
                >
                  <i
                    class="gf-icon"
                    :class="isOpenedConflictsIcon"
                  ></i>
                </button>
                <button
                  v-if="
                    requirementStatus.mergeRequestRequirement === 'NO_LOCK_CONFLICTS' &&
                    !requirementStatus.accepted
                  "
                  class="btn btn-sm merge-area__open-conflicts ml-2"
                  @click="isOpenLocks = !isOpenLocks"
                >
                  <i :class="isOpenedLocksConflictsIcon"></i>
                </button>
              </div>
              <div
                class="conflicts-list"
                v-if="
                  requirementStatus.mergeRequestRequirement === 'NO_CONFLICTS' &&
                  !requirementStatus.accepted &&
                  isOpenConflicts
                "
              >
                <div
                  class="overflow-auto"
                  :class="{ 'pb-2': mergeRequest.conflicts.length < 3 }"
                >
                  <div
                    class="mt-2 text-nowrap"
                    v-for="(file, index) in mergeRequest.conflicts"
                    :key="index"
                  >
                    <span class="text-muted">{{ index + 1 }}.&nbsp;</span>
                    <i class="gf-icon gf-icon-file-delete merge-area__file-icon text-muted"></i>
                    {{ file }}
                  </div>
                </div>
              </div>
              <button
                v-if="
                  requirementStatus.mergeRequestRequirement === 'NO_LOCK_CONFLICTS' &&
                  !requirementStatus.accepted
                "
                class="btn btn-sm merge-area__open-conflicts ml-1"
                @click="isOpenLocks = !isOpenLocks"
              >
                <i
                  class="gf-icon"
                  :class="isOpenedLocksConflicsIcon"
                ></i>
              </button>
              <div
                v-if="
                  requirementStatus.mergeRequestRequirement === 'NO_LOCK_CONFLICTS' &&
                  !requirementStatus.accepted &&
                  isOpenLocks
                "
                class="conflicts-list"
              >
                <div
                  class="overflow-auto"
                  :class="{ 'pb-2': mergeRequest.lockConflicts.length < 3 }"
                >
                  <div
                    v-for="(file, index) in mergeRequest.lockConflicts"
                    :key="index"
                    class="mt-2 text-nowrap"
                  >
                    <span class="text-muted">{{ index + 1 }}.&nbsp;</span>
                    <i class="gf-icon gf-icon-file-delete merge-area__file-icon text-muted"></i>
                    {{ file?.filePath }}
                    <span class="blocked-by">&nbsp;заблокирован @{{ file?.lockedBy }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex px-3 pb-3 pt-2 align-items-center">
          <div class="flex-column">
            <div
              aria-label="Button group with nested dropdown"
              class="btn-group btn-group-sm"
              role="group"
            >
              <button
                class="btn"
                :class="mergeRequest.canMerge ? 'btn-success' : 'btn-warning'"
                type="submit"
                :data-target="'createMergeMessage-' + $route.params.id"
                :disabled="
                  !mergeRequest.canMerge ||
                  mergeRequest?.autoMergeEnabled ||
                  !getActionAvailabilityFlag(ACTION_ENUM.DO_MERGE_MERGE_REQUEST)
                "
                @click.prevent="confirmBoxText('merge')"
              >
                {{ $t('message.merge') }}
              </button>
              <div
                class="btn-group btn-group-sm"
                role="group"
              >
                <button
                  aria-expanded="false"
                  aria-haspopup="true"
                  class="btn dropdown-toggle"
                  :class="mergeRequest.canMerge ? 'btn-success' : 'btn-warning'"
                  :disabled="mergeRequest.isMergeTrainRunning"
                  data-toggle="dropdown"
                  type="button"
                ></button>
                <div
                  aria-labelledby="btnGroupDrop1"
                  class="dropdown-menu"
                >
                  <a
                    class="dropdown-item js-button-cancel"
                    href="#"
                    data-target="confirmMergeModal"
                    @click.prevent="confirmBoxText('cancel')"
                  >
                    {{ $t('message.cancel') }}
                  </a>
                  <a
                    class="dropdown-item js-button-close"
                    href="#"
                    data-target="confirmMergeModal"
                    @click.prevent="confirmBoxText('close')"
                  >
                    {{ $tc('message.close', 2) }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-column ml-3">
            <div
              class="d-flex"
              v-if="isMergeTrainsEnabled"
            >
              {{ $t('merge_request_cmd_train') }}
              <gf-custom-tooltip
                position="top"
                width="250px"
                :show-on-mobile-version="true"
                class="ml-1"
              >
                <template #element>
                  <div class="d-flex align-items-center">
                    <i class="gf-icon gf-icon-question-circle"></i>
                  </div>
                </template>
                <template #content>
                  <span>{{ $t('merge_request_train_description') }}</span>
                </template>
              </gf-custom-tooltip>
            </div>
            <span v-else>{{ $t('merge_request_cmd') }}</span>
          </div>
        </div>
      </div>
    </div>

    <gf-custom-modal-window
      ref="gfCustomModalWindowCreateMerge"
      :gf-modal-data-name="'createMergeMessage-' + $route.params.id"
      :gf-modal-header="$t('titleMergeCommitField')"
      gf-modal-wrapper-width="500px"
    >
      <template #body>
        <merge-request-item-merge-area-form
          ref="mergeRequestAreaForm"
          :mergeMessage="mergeRequest?.defaultMergeCommitMessage"
          :squashMessage="mergeRequest?.defaultSquashCommitMessage"
          :disabledField="mergeRequest?.canEditMergeCommitMessage"
          :isSquashCommit="mergeRequest?.squashCommit"
          @close="closeCreateMergeModal"
          @send="sendEditCommitMessage"
        ></merge-request-item-merge-area-form>
      </template>
    </gf-custom-modal-window>

    <gf-custom-modal-window
      ref="gfCustomModalWindowConfirmMerge"
      gf-modal-data-name="confirmMergeModal"
      :gf-modal-header="confirmMessage"
      gf-modal-wrapper-width="500px"
    >
      <template #body>
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-secondary btn-sm m-1"
            @click="closeConfirmMergeModal"
          >
            {{ $t('message.cancel') }}
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm m-1"
            @click="submit"
          >
            {{ $t('message.continue') }}
          </button>
        </div>
      </template>
    </gf-custom-modal-window>
  </section>
</template>

<script>
import mergeRequestMessages from '@shared/modules/merge-request/mergeRequestMessages';
import mergeRequestItemMergeAreaForm from './merge-request-item-merge-area-form.vue';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import mergeRequestService from '@shared/modules/merge-request/mergeRequest.service';
import GfCustomTooltip from '@/shared-modules/shared-components/shared/GfCustomTooltip.vue';

export default {
  name: 'MergeRequestItemMergeArea',
  components: {
    GfCustomTooltip,
    mergeRequestItemMergeAreaForm
  },
  props: ['mergeRequest'],
  data() {
    return {
      confirmMessage: null,
      confirmMessageType: null,
      isOpenMergeRequirements: false,
      isOpenConflicts: false,
      isOpenLocks: false,
      isMergeTrainsEnabled: false,
      canMerge: true
    };
  },
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    isOpenedMergeRequirementsIcon() {
      return this.isOpenMergeRequirements ? 'gf-icon-chevron-up' : 'gf-icon-chevron-down';
    },
    isOpenedConflictsIcon() {
      return this.isOpenConflicts ? 'gf-icon-chevron-up' : 'gf-icon-chevron-down';
    },
    isOpenedLocksConflicsIcon() {
      return this.isOpenLocks ? 'gf-icon-chevron-up' : 'gf-icon-chevron-down';
    }
  },
  mounted() {
    this.isOpenMergeRequirements = !this.mergeRequest.canMerge;
    this.isMergeTrainsEnabled = document.getElementById('mergeTrainsEnabled')?.value === 'true';
  },
  methods: {
    confirmBoxText(type) {
      if (type === 'cancel') {
        this.confirmMessageType = 'cancel';
        this.confirmMessage = this.$t('merge_request_confirm_cancel');
      } else if (type === 'close') {
        this.confirmMessageType = 'close';
        this.confirmMessage = this.$t('merge_request_confirm_close');
      } else if (type === 'merge') {
        this.confirmMessageType = 'merge';
        this.confirmMessage = this.$t('merge_request_confirm_merge');
      }
    },
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    sendEditCommitMessage(message) {
      mergeRequestService
        .sendEditMergeCommitMessage(
          this.$route.params.alias,
          this.$route.params.projectAlias,
          this.$route.params.id,
          {
            commitMessage: message.mergeMessage,
            squashCommitMessage: this.mergeRequest?.squashCommit ? message.squashMessage : ''
          }
        )
        .then((res) => {
          if (res.status === 200) {
            window.location.href = `/project/${this.$route.params.alias}/${this.$route.params.projectAlias}/merge-request/${this.$route.params.id}`;
          }
        })
        .catch(() => {
          this.$refs.mergeRequestAreaForm.enableSubmitButton();
        });
    },
    closeCreateMergeModal() {
      this.$refs.gfCustomModalWindowCreateMerge.closeModalWindow();
    },
    closeConfirmMergeModal() {
      this.$refs.gfCustomModalWindowConfirmMerge.closeModalWindow();
    },
    submit() {
      this.$emit(this.confirmMessageType);
      this.closeConfirmMergeModal();
    }
  },
  i18n: {
    messages: mergeRequestMessages
  }
};
</script>

<style lang="scss">
$this: '.merge-area';

#{$this} {
  #{$this}__open-requirements {
    margin-left: auto;
    display: flex;
    gap: 12px;

    & > button {
      background-color: var(--bg-light);

      &:hover {
        background-color: var(--bg-light-selected);
      }
    }
  }
  #{$this}__requirement-status {
    & i {
      font-size: 25px;
    }
  }
  #{$this}__open-conflicts {
    padding: 0.1rem 0.3rem;
    background-color: var(--bg-light);
    border: 1px solid var(--border-color);

    &:hover {
      background-color: var(--bg-light-selected);
    }

    & i {
      font-size: 14px !important;
    }
  }
  #{$this}__file-icon {
    margin-right: 2px;
    font-size: 14px !important;
  }

  .conflicts-list {
    margin-left: 29px;
    font-family: 'JetBrains Mono';
    font-size: 12px;

    .blocked-by {
      font-family: sans-serif;
    }
  }
}
</style>
